import { UserSimulation } from '@carbon/react/icons';
import React from 'react';
//import { useSpring, animated } from 'react-spring';

const AnimatedImposter = () => {
  /*const props = useSpring({
    from: { color: 'red' },
    to: async (next) => {
      while (1) {
        await next({ color: 'white' });
        await next({ color: 'red' });
      }
    },
  });*/ //

  return (
    //<animated.div style={props}>
    <UserSimulation size="20" />
    //</animated.div>
  );
};

export default AnimatedImposter;
